"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmlCtfLawsRegulations = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AmlCtfLawsRegulations = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.aml_ctf_laws_regulations.label',
    fallbackLabel: 'Please outline the main laws and regulations related to Anti Money Laundering and Counter Terrorist Financing that you are required to follow, including any regulations concerning funds transfers.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
